import { render, staticRenderFns } from "./BaseBFilter.vue?vue&type=template&id=9deec942&scoped=true"
import script from "./BaseBFilter.vue?vue&type=script&lang=js"
export * from "./BaseBFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9deec942",
  null
  
)

export default component.exports